import type { Event } from '@sentry/react';

export const UNAUTHENTICATED_ERROR = 'No current user';
const blackListErrorMessages = [UNAUTHENTICATED_ERROR];

const DEBUG = localStorage.getItem('DEBUG') === 'true';

export const beforeSend = (event: Event): PromiseLike<Event | null> | Event | null => {
  if (DEBUG) {
    console.info('🚀 ~ file: sentryFunctions.ts ~ line 7 ~ event', event);
  }

  if (event.message && blackListErrorMessages.includes(event.message)) {
    return null;
  }

  return event;
};

export default { beforeSend };
